import L from "leaflet";
import "leaflet.gridlayer.googlemutant";
import "leaflet/dist/leaflet.css";

import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import 'leaflet-imageoverlay-rotated';
let mapInstance = null;
let resizeObserverInstance = null;

// Remove map listner for
let keydownHandler = null;
let keyupHandler = null;
let wheelHandler = null;
const isMobile = window.innerWidth <= 768;

let enableScrollWheelZoom = isMobile ? false: true;

// Adding cleanup for listener and map
const cleanup = () => {
  if (resizeObserverInstance) {
    resizeObserverInstance.disconnect();
    resizeObserverInstance = null;
  }
  if (window.masterplanMap) {
    window.masterplanMap = null;
  }

  if (keydownHandler) {
    document.removeEventListener("keydown", keydownHandler);
    keydownHandler = null;
  }
  if (keyupHandler) {
    document.removeEventListener("keyup", keyupHandler);
    keyupHandler = null;
  }

  if (wheelHandler && window.masterplanMap) {
    L.DomEvent.off(window.masterplanMap.getContainer(), "wheel", wheelHandler);
    wheelHandler = null;
  }
};

// helper function to calculate the pixel distance between two points
const calculateDistance = function (x1, y1, x2, y2) {
  const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  return distance;
};

// ----- RESIZE OBSERVER ----- //
function initResizeObserver() {
  const resizeObserver = new ResizeObserver(() => {
    masterplanMap.invalidateSize();
  });

  return resizeObserver;
}


// ----- CMD/CTRL SCROLL LISTENER ----- //
function initScrollListener() {
  // reference the helper/tooltip element
  const scrollTip = document.getElementById("mapScrollTooltip");
  let isCtrlCmdPressed = false;

  // if scroll-wheel-zoom is enabled, nothing else to do here.
  if (enableScrollWheelZoom) {
    scrollTip.classList.remove("active");
    return;
  }

  // Listen for keydown and keyup events to track the Control/Command key
  keydownHandler = (e) => {
    if (e.key === "Control" || e.key === "Meta") {
      isCtrlCmdPressed = true;
    }
  };

  keyupHandler = (e) => {
    if (e.key === "Control" || e.key === "Meta") {
      isCtrlCmdPressed = false;
    }
  };
  wheelHandler = (e) => {
    if (isCtrlCmdPressed) {
      masterplanMap.scrollWheelZoom.enable();
      scrollTip.classList.remove("active");
      masterplanMap.once("zoomend", () => {
        setTimeout(() => {
          masterplanMap.scrollWheelZoom.disable();
        }, 250);
      });
    }
  };
  document.addEventListener("keydown", keydownHandler);
  document.addEventListener("keyup", keyupHandler);

  // Enable scroll zoom only when the Control/Command key is pressed
  L.DomEvent.on(masterplanMap.getContainer(), "wheel", wheelHandler);
}

// ----- LOT SHAPES CLICK HANDLER ----- //
// const initLotShapesHandler = function (map) {
//   const releaseMaps = [];
//   const releaseMapEls = map.querySelectorAll("svg[data-release]");
//   releaseMapEls.forEach((el) => {
//     // only select the first-level children elements of each releaseMapEl,
//     // where each child is a path, polygon, rect or g element
//     const lotShapeEls = el.querySelectorAll("path, polygon, rect, g");

//     if (lotShapeEls.length > 0) {
//       const lotShapes = [];
//       lotShapeEls.forEach((shape) => {
//         // calculate the lotId from the shape's ID i.e. "LOT_2756_Pine_Valley_R2"
//         const lotData = _lotNameDeCombobulator(shape.id);
//         lotShapes.push({
//           el: shape,
//           data: lotData,
//         });
//       });
//       // add a click handler to each shape, as well as a status CSS class, based on the matching lot in lanserCommunity.lots
//       lotShapes.forEach((shape) => {
//         shape.el.addEventListener("click", function () {
//           masterplanControls.showLotDetails(shape.data);
//         });
//         // add a status CSS class to the shape, based on the matching lot in lanserCommunity.lots
//         const lot = lanserCommunity.lots.find(
//           (lot) => lot.lotNo == shape.data.lotNo
//         );
//         if (lot) {
//           shape.el.classList.add(`status-${lot.status.toLowerCase()}`);
//         }
//       });
//       // push it all up to the releaseMaps array
//       releaseMaps.push({
//         id: el.dataset.releaseId,
//         slug: el.dataset.releaseSlug,
//         lotShapes: lotShapes,
//       });
//     }
//   });
// };

// ----- LOT SHAPES CLICK HANDLER (Optimized) ----- //
const initLotShapesHandler = function (map) {
  const releaseMaps = [];
  const releaseMapEls = map.querySelectorAll("svg[data-release]");
  
  const lots = lanserCommunity.lots;
  const lotLookup = new Map();
  for (let i = 0; i < lots.length; i++) {
    lotLookup.set(String(lots[i].lotNo), lots[i]);
  }
  
  for (let i = 0; i < releaseMapEls.length; i++) {
    const el = releaseMapEls[i];
    
    const lotShapeEls = el.querySelectorAll("path,polygon,rect");
    
    if (!lotShapeEls.length) continue;
    
    const lotShapes = new Array(lotShapeEls.length); 
    
    for (let j = 0; j < lotShapeEls.length; j++) {
      const shape = lotShapeEls[j];
      const lotData = _lotNameDeCombobulator(shape.id);
      
      if (!lotData?.lotNo) continue;
      
      lotShapes[j] = {
        el: shape,
        data: lotData,
        lot: lotLookup.get(String(lotData.lotNo)) 
      };
    }
    
    const validLotShapes = lotShapes.filter(Boolean);
    
    for (let j = 0; j < validLotShapes.length; j++) {
      const shape = validLotShapes[j];
      
      shape.el.addEventListener("click", handleLotClick);
      shape.el._lotData = shape.data; 
      
      if (shape.lot?.status) {
        shape.el.classList.add(`status-${shape.lot.status.toLowerCase()}`);
      }
    }
    
    releaseMaps.push({
      id: el.dataset.releaseId,
      slug: el.dataset.releaseSlug,
      lotShapes: validLotShapes,
    });
  }
  
  return releaseMaps;
};

function handleLotClick(event) {
  if (masterplanControls?.showLotDetails && this._lotData) {
    masterplanControls.showLotDetails(this._lotData);
  }
}

// ----- PRECINCT SHAPES CLICK HANDLER //
const initPrecinctShapesHandler = function (map) {
  const precinctMapEls = map.querySelectorAll("svg[data-precinct]");
  precinctMapEls.forEach((el) => {
    el.addEventListener("click", function () {
      // reference the masterplan control dataset from in the DOM,
      // to fire off the appropriate zoomToArea function
      const controlEl = document.querySelector(
        `.masterplan-control-button[data-precinct-id="${el.dataset.precinctId}"]`
      );
      if (controlEl) {
        masterplanControls.zoomToArea(
          controlEl.dataset.lat,
          controlEl.dataset.lng,
          window.lanserCommunity.base.precinctZoomCutoff
        );
      } else {
        console.warn(
          `No matching control element found for precinct '${el.dataset.precinctId}'`
        );
      }
    });
  });
};

// ----- PRECINCT MARKERS CLICK/HOVER HANDLER ----- //
const bindPrecinctMarkers = function (bind = true, zoomLevel = 18, mapLayerGroups) {
  if (!bind) {
    mapLayerGroups.precinctMarkers.clearLayers();
    return;
  }
  // Clear the existing markers layer group if it exists, and
  if (mapLayerGroups.precinctMarkers) {
    mapLayerGroups.precinctMarkers.clearLayers();
  } else {
    mapLayerGroups.precinctMarkers = L.layerGroup().addTo(masterplanMap);
  }

  // Loop through precinct layers and add markers
  mapLayerGroups.precincts.eachLayer(function (layer) {
    const precinctSlug = layer._image.dataset.precinctSlug;
    const precinctItem = window.lanserCommunity.precincts.find(
      (precinct) => precinct.slug === precinctSlug
    );

    // only proceed if a matching precinct was found in the lanserCommunity.precincts array
    if (precinctItem) {
      // grab a reference to the precinct outline layer on the map in case we need it
      // const precinctOutlineEl = document.querySelector(`.precinctmap[data-precinct-slug="${precinctItem.slug}"]`)

      // dynamic Icon size based on the zoom level (higher zoom = larger icon)
      const iconSizes = [
        { zoom: 18, size: [150, 50] },
        { zoom: 16, size: [125, 40] },
        { zoom: 14, size: [100, 30] },
        { zoom: 12, size: [100, 30] },
      ];
      const iconAnchors = [
        { zoom: 18, anchor: [75, 25] },
        { zoom: 16, anchor: [62.5, 20] },
        { zoom: 14, anchor: [50, 15] },
        { zoom: 12, anchor: [50, 15] },
      ];
      // const iconSize = iconSizes.find((size) => zoomLevel >= size.zoom);
      // const iconAnchor = iconAnchors.find(
      //   (anchor) => zoomLevel >= anchor.zoom
      // );

      // Create the DivIcon for the marker
      const markerIcon = L.divIcon({
        className: `precinct-marker ${precinctItem.slug}`,
        html: `<div class="precinct-marker-content">${precinctItem.title}</div>`,
        iconSize: [125, 40],
        iconAnchor: [62.5, 20],
      });

      // Create the marker and add it to the layer group
      const marker = L.marker([precinctItem.lat, precinctItem.lng], {
        icon: markerIcon,
        bubblingMouseEvents: false,
        precinctData: precinctItem,
      });

      // click handler
      marker.on("click", function (e) {
        const precinctData = e.target.options.precinctData;
        masterplanControls.zoomToArea(
          precinctData.lat,
          precinctData.lng,
          window.lanserCommunity.base.precinctZoomCutoff
        );
      });

      // mouseover/out hover effect handlers
      marker
        .on("mouseover", function (e) {
          const precinctData = e.target.options.precinctData;
          const precinctOutlineEl = document.querySelector(
            `.precinctmap[data-precinct-slug="${precinctData.slug}"]`
          );
          if (precinctOutlineEl) {
            precinctOutlineEl.classList.add("hovering");
          }
        })
        .on("mouseout", function (e) {
          const precinctData = e.target.options.precinctData;
          const precinctOutlineEl = document.querySelector(
            `.precinctmap[data-precinct-slug="${precinctData.slug}"]`
          );
          if (precinctOutlineEl) {
            precinctOutlineEl.classList.remove("hovering");
          }
        });

      // Finally add the marker to the precinct markers layer group
      mapLayerGroups.precinctMarkers.addLayer(marker);
    } else {
      console.warn(
        `No matching precinct found for slug '${precinctSlug}' when binding markers`
      );
    }
  });
};


// ----- Master Plan Controls ----- //
const masterplanControls = {
  zoomToArea: function (
    lat,
    lng,
    zoom = window.window.lanserCommunity.base.precinctZoomCutoff
  ) {
    const zoomDepth =
      zoom + 1 > window.lanserCommunity.base.zoomMax
        ? window.lanserCommunity.base.zoomMax
        : zoom + 1;
    window.masterplanMap.setView([lat, lng], zoomDepth, { animate: true });
  },
  showLotDetails: function (lotData) {
    // determine the lot to show based on the lotData supplied
    const selectedLot = window.lanserCommunity.lots.find((lot) => {
      // originally looked for a relasename in the ltoData, but now we're looking for the communityName..
      // return (lot.lotNo == lotData.lotNo) && (lot.releaseSlug.toLowerCase().includes(lotData.releaseName.toLowerCase()))

      // gotta kebabize the lot.communityHandle.. eww..
      // const communitySlug = utils.kebabize(lot.communityHandle)
      // return (lot.lotNo == lotData.lotNo) && (communitySlug.includes(lotData.communityName.toLowerCase()))
      return lot.lotNo == lotData.lotNo;
    });
    if (selectedLot) {
      // dispatch custom window event 'showlotdetails' with the lotId as the detail
      window.dispatchEvent(
        new CustomEvent("showlotdetails", { detail: selectedLot.id })
      );
    } else {
      console.warn(
        `No matching lot number ${lotData.lotNo} found in release '${lotData.communityName}'`
      );
    }
  },
  showAmenityDetails: function (amenitySlug) {
    // dispatch custom window event 'showamenitydetails' with the lotId as the detail
    window.dispatchEvent(
      new CustomEvent("showamenitydetails", { detail: amenitySlug })
    );
  },
};

// ----- LOT CIRCLES ----- //
const generateLotCircles = function (map, lots, interactive = false) {
  const lotCircles = [];
  const lotcirclRednders = L.canvas({
          pane: 'nonInteractivePane',
          interactive: false
        });
  for (let i = 0; i < lots.length; i++) {
    const lot = lots[i];

    let fillColor;
    switch (lot.status.toLowerCase()) {
      case "available":
        fillColor = "#b5d358";
        break;
      case "on hold":
        fillColor = "#ffc84b";
        break;
      case "deposit taken":
        fillColor = "#ffc84b";
        break;
      case "closed":
      case "sold":
        fillColor = "#F54B4B";
        break;
      default:
        fillColor = "#ffc84b";
        break;
    }

    if (lot.lat && lot.lng) {
      const circle = L.circleMarker([lot.lat, lot.lng], {
        radius: 1.5,
        fillColor: fillColor,
        color: fillColor,
        fillOpacity: 1,
        renderer:lotcirclRednders
      });
      // .bindPopup(`Lot ${lot.lotNo}`)
      lotCircles.push(circle);

      if (interactive) {
        circle.on("click", function () {
          masterplanControls.showLotDetails(lot);
        });
      }
    }
  }
  return lotCircles;
};

// Helper function to parse the lotId into a lotNo, releaseName & releaseId
const _lotNameDeCombobulator = function (lotId) {
  // LOT_2756_Pine-Valley_R2 -> { lotNo: 2756, name: Pine-Valley, release: R2 }
  // Update Nov 2024: changed the format to LOT_2756_aston-hills -> { lotNo: 2756, name: aston-hills }
  const parts = lotId.split("_");
  if (parts.length !== 3) {
    console.warn(
      `Invalid lotId format: ${lotId} - expected 4 parts, got ${parts.length}`
    );
  }
  return {
    lotNo: parts[1] ?? null,
    communityName: parts[2] ?? null, // used to be 'releaseName' but... client..
    // releaseId: parts[3] ?? null,
  };
};

// Helper function to move a point by a given distance and direction
const _moveLatLng = function (lat, lng, distance, direction) {
  const earthRadius = 6371000; // meters
  const rad = Math.PI / 180; // Convert degrees to radians

  // Convert latitude and longitude to numbers (in case they are strings)
  lat = parseFloat(lat);
  lng = parseFloat(lng);
  distance = parseFloat(distance);

  // Adjust latitude
  if (direction === "north" || direction === "south") {
    const newLat = lat + (distance / 111320) * (direction === "north" ? 1 : -1);
    return { lat: newLat, lng: lng };
  }

  // Adjust longitude
  else if (direction === "east" || direction === "west") {
    const newLng =
      lng +
      (distance / (111320 * Math.cos(lat * rad))) *
        (direction === "east" ? 1 : -1);
    return { lat: lat, lng: newLng };
  }

  // If direction is invalid
  else {
    console.error(
      'Invalid direction specified. Use "north", "south", "east", or "west".'
    );
    return null;
  }
};

// Function to toggle layer groups within a map
const toggleLayerGroup = function (map, layerGroup, force = null) {
  if (typeof layerGroup === "undefined") {
    console.error("toggleLayerGroup: layerGroup is undefined");
    return false;
  }
  // if force is true or false, we force the layerGroup to be enabled or disabled and exit.
  if (force !== null) {
    if (force) {
      map.addLayer(layerGroup);
    } else {
      map.removeLayer(layerGroup);
    }
    return true;
  }
  // otherwise, we toggle the layerGroup based on whether it is already enabled or not
  if (map.hasLayer(layerGroup)) {
    map.removeLayer(layerGroup);
  } else {
    map.addLayer(layerGroup);
  }
  return true;
};

// Function to toggle a specific amenity layerGroup, and also
const toggleAmenityLayerGroup =  (
  map,
  layerGroup = lanserCommunityId == 6
    ? "amenities__parks-recreation"
    : "amenities__display-village",
  mapLayerGroups
) => {
  // loop the mapLayerGroups object and where the key does not start with 'amenities__', turn off the layerGroup
  Object.keys(mapLayerGroups).forEach((key) => {
    if (key !== layerGroup && key.startsWith("amenities__")) {
      toggleLayerGroup(map, mapLayerGroups[key], false);
    }
  });
  // turn on the layerGroup that was clicked
  if (layerGroup) {
    const theLayerGroup = mapLayerGroups[layerGroup];
    toggleLayerGroup(map, theLayerGroup, true);
  }
  return true;
};

// ----- ZOOM LISTENER ----- //
function initZoomListener(mapLayerGroups) {
    let currentZoomState = null;

  masterplanMap.on("zoomend", () => {
    const zoomLevel = masterplanMap.getZoom();
    const percientZoom = zoomLevel < window.lanserCommunity.base.precinctZoomCutoff;
    if (currentZoomState === percientZoom) return;
    currentZoomState = percientZoom;
    // zoom Level is further away, show the precincts
    if (percientZoom) {
      // Enable precincts and disable releases & lot circles
      toggleLayerGroup(masterplanMap, mapLayerGroups.precincts, true);
      toggleLayerGroup(masterplanMap, mapLayerGroups.releases, false);
      toggleLayerGroup(masterplanMap, mapLayerGroups.lotCircles, false);
      // also re-bind markers to each precinct
      bindPrecinctMarkers(true, zoomLevel, mapLayerGroups);
    } else {
      // Enable releases/lot numbers and disable precincts & precinct markers
      toggleLayerGroup(masterplanMap, mapLayerGroups.precincts, false);
      toggleLayerGroup(masterplanMap, mapLayerGroups.releases, true);
      toggleLayerGroup(masterplanMap, mapLayerGroups.lotCircles, true);
      bindPrecinctMarkers(false, zoomLevel, mapLayerGroups);
    }
  });
}

function loadImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener("load", () => resolve(img));
        img.addEventListener("error", reject);
        img.src = url;
    });
}

const createTiledImageOverlay = async (imageSrc, bounds, opacity = 1, tileSize = 512, timeout = 30000) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const blobUrls = []; // Track all blob URLs for cleanup
    let hasError = false;
    let timeoutId;
    
    // Timeout protection
    timeoutId = setTimeout(() => {
      if (!hasError) {
        cleanup();
        reject(new Error('Image load timeout'));
      }
    }, timeout);
    
    const cleanup = () => {
      clearTimeout(timeoutId);
      blobUrls.forEach(url => URL.revokeObjectURL(url));
      img.src = '';
    };
    
    const createFallbackOverlay = () => {
      cleanup();
      const overlay = L.imageOverlay(imageSrc, bounds, {
        opacity: opacity,
        zIndex: 1
      });
      resolve(overlay);
    };
    
    img.onload = async () => {
      clearTimeout(timeoutId);
      
      try {
        const cols = Math.ceil(img.width / tileSize);
        const rows = Math.ceil(img.height / tileSize);
        const layerGroup = L.layerGroup();
        
        const latDiff = bounds.getNorth() - bounds.getSouth();
        const lngDiff = bounds.getEast() - bounds.getWest();
        
        // Create all tiles before adding to layer group
        const tilePromises = [];
        
        for (let row = 0; row < rows; row++) {
          for (let col = 0; col < cols; col++) {
            const tilePromise = new Promise((resolveTile, rejectTile) => {
              try {
                const canvas = document.createElement('canvas');
                canvas.width = Math.min(tileSize, img.width - col * tileSize);
                canvas.height = Math.min(tileSize, img.height - row * tileSize);
                
                const ctx = canvas.getContext('2d', { 
                  alpha: opacity < 1,
                  willReadFrequently: false
                });
                
                if (!ctx) {
                  throw new Error('Failed to get canvas context');
                }
                
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'medium';
                
                ctx.drawImage(
                  img,
                  col * tileSize,
                  row * tileSize,
                  canvas.width,
                  canvas.height,
                  0,
                  0,
                  canvas.width,
                  canvas.height
                );
                
                // Calculate tile bounds
                const tileSouth = bounds.getSouth() + (latDiff * (rows - row - 1) / rows);
                const tileNorth = bounds.getSouth() + (latDiff * (rows - row) / rows);
                const tileWest = bounds.getWest() + (lngDiff * col / cols);
                const tileEast = bounds.getWest() + (lngDiff * (col + 1) / cols);
                const tileBounds = L.latLngBounds(
                  [tileSouth, tileWest],
                  [tileNorth, tileEast]
                );
                
                canvas.toBlob((blob) => {
                  if (!blob) {
                    canvas.width = 0;
                    canvas.height = 0;
                    rejectTile(new Error('Blob creation failed'));
                    return;
                  }
                  
                  const blobUrl = URL.createObjectURL(blob);
                  blobUrls.push(blobUrl);
                  
                  const tileOverlay = L.imageOverlay(blobUrl, tileBounds, {
                    opacity: opacity,
                    zIndex: 1,
                    className: `tile-${row}-${col}`,
                  });
                  
                  // Clean up canvas
                  canvas.width = 0;
                  canvas.height = 0;
                  
                  resolveTile(tileOverlay);
                }, 'image/png', 0.85);
                
              } catch (error) {
                rejectTile(error);
              }
            });
            
            tilePromises.push(tilePromise);
          }
        }
        
        // Wait for all tiles to be created
        const tiles = await Promise.all(tilePromises);
        
        // Add all tiles to layer group
        tiles.forEach(tile => tile.addTo(layerGroup));
        
        // Set up cleanup on layer removal
        layerGroup.on('remove', cleanup);
        
        resolve(layerGroup);
        
      } catch (error) {
        console.error('Tiled overlay error:', error);
        createFallbackOverlay();
      }
    };
    
    img.onerror = (error) => {
      clearTimeout(timeoutId);
      console.error('Image load error:', error);
      reject(new Error(`Failed to load image: ${imageSrc}`));
    };
    
    // Enable CORS if needed
    img.crossOrigin = 'anonymous';
    img.src = imageSrc;
  });
};


// Generate Tiles
async function generateTilesInBrowser(imageUrl, tileSize = 256) {
  const img = new Image();
  img.crossOrigin = 'anonymous';
  
  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = imageUrl;
  });
  
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = tileSize;
  canvas.height = tileSize;
  
  const tiles = {};
  const zoom = 2; // Example zoom level
  const scale = Math.pow(2, zoom);
  
  const tilesX = Math.ceil((img.width * scale) / tileSize);
  const tilesY = Math.ceil((img.height * scale) / tileSize);
  
  for (let x = 0; x < tilesX; x++) {
    for (let y = 0; y < tilesY; y++) {
      ctx.clearRect(0, 0, tileSize, tileSize);
      
      ctx.drawImage(
        img,
        (x * tileSize) / scale,
        (y * tileSize) / scale,
        tileSize / scale,
        tileSize / scale,
        0,
        0,
        tileSize,
        tileSize
      );
      
      tiles[`${zoom}/${x}/${y}`] = canvas.toDataURL('image/png');
    }
  }
  
  return tiles;
}


// Main Map for masterplan
const initInteractiverMasterplan = async () => {
  // Clean up
  cleanup();
  // look for a document ID of #leafletMap
  const theMapWrapper = document.getElementById("leafletMapWrapper");
  const theMapEl = document.getElementById("leafletMap");

  const amenityLayerControls = document.querySelectorAll("[data-toggle-layer]");

  if (!theMapEl) return;
  const mapType = "google"; // 'google' or 'osm'
  // define the map centre point based on user-given data attributes
  const mapLat = theMapEl.getAttribute("data-map-center-lat");
  const mapLng = theMapEl.getAttribute("data-map-center-lng");
  const mapZoom = theMapEl.getAttribute("data-map-zoom") ?? 15;
  // define the community map layer bounds
  const lanserCommunityId = window.lanserCommunityId ?? null;
  const displayLotShapes = window.lanserCommunity.displayLotShapes ?? false;
  const baseMapLayerBounds =
    window.lanserCommunity.base.baseMapLayerBounds ?? [];
  const baseMapScaleFactor = window.lanserCommunity.base.imgScaleFactor ?? 1;
  const baseMapImageSrc = window.lanserCommunity.base.imgSrc ?? "";
  const baseMapImageSrcMobile = window.lanserCommunity.base.imgSrcMobile ?? "";
  const baseMapWidth = Number(window.lanserCommunity.base.imgWidth) ?? 1;
  const baseMapHeight = Number(window.lanserCommunity.base.imgHeight) ?? 1;
  const baseMapOpacity = window.lanserCommunity.base.imgOpacity ?? 1;
  const amenities = window.lanserCommunity.amenities ?? [];
  const baseMapImageLoad = await loadImage(baseMapImageSrc);
  let mapSrc = baseMapImageSrc;

  // Handle If baseMapImageSrcMobile is not empty and window width to check for responisve
  let baseMapImageMobileLoad;
  const isMobilehasmobileImageSet = window.innerWidth <= 768 && baseMapImageSrcMobile != "";
  if(isMobilehasmobileImageSet){
      mapSrc = baseMapImageSrcMobile;
     baseMapImageMobileLoad = await loadImage(baseMapImageSrcMobile);
  }
  if (baseMapLayerBounds.length < 1) {
    console.error("Whoops! No map layer bounds provided in CMS!");
    return;
  }
  // Determine all unique amenity categories from the amenities array,
  // so we can create a layerGroup for each category
  const allAmenityCategories = Array.from(
    new Set(
      amenities.map((amenity) =>
        JSON.stringify({
          title: amenity.category,
          slug: amenity.categorySlug,
        })
      )
    )
  ).map(JSON.parse);

  // define all of the final control layergroup objects in a handy object for later
  let mapLayerGroups = {
    lotCircles: L.layerGroup(),
    radiuses: L.layerGroup(),
    releases: L.layerGroup(),
    stages: L.layerGroup(),
    precincts: L.layerGroup(),
  };

  // Add amenity category
  // allAmenityCategories.forEach((cat) => {
  //   const catSlug = 'amenities__' + cat.slug;
  //   mapLayerGroups[catSlug] = L.layerGroup();
  // });

  // Added clustering
  allAmenityCategories.forEach((cat) => {
    const catSlug = "amenities__" + cat.slug;
    mapLayerGroups[catSlug] = L.markerClusterGroup({
      maxClusterRadius: 80,
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
      disableClusteringAtZoom: 18,
      spiderfyDistanceMultiplier: 1.5,
    });
  });

  // Also define a function to handle the amenity layer control buttons via external DOM elements
  amenityLayerControls.forEach((el) => {
    el.addEventListener("click", function () {
      // const result = toggleLayerGroup(masterplanMap, mapLayerGroups[el.dataset.toggleLayer])
      // if (!result) {
      //     console.error(`Layer group ${el.dataset.toggleLayer} not found in layerGroups (${Object.keys(mapLayerGroups).join(', ')})`)
      // }
      const result = toggleAmenityLayerGroup(
        masterplanMap,
        el.dataset.toggleLayer,
        mapLayerGroups
      );
      if (!result) {
        console.error(
          `Layer group ${
            el.dataset.toggleLayer
          } not found in layerGroups (${Object.keys(mapLayerGroups).join(
            ", "
          )})`
        );
      }
    });
  });

  // ====================

  // ----- MAP TILE LAYER OPTS ----- //
  let tileLayer = null;

  // Note: Maps created in Google Cloud Console NEED to use the "raster" rendering type, NOT "vector"..
  // otherwise we just get a grey map with no errors and everyone has a bad time trying to debug WTF is going on.  See:
  // https://gitlab.com/IvanSanchez/Leaflet.GridLayer.GoogleMutant/-/issues/144

  switch (mapType) {
    case "google":
      // Add Google Mutant layers
      tileLayer = L.gridLayer.googleMutant({
        type: "roadmap",
        version: "beta",
        mapId: window.lanserCommunity.base.mapId,
      });

      break;
    case "osm":
      // Add OSM tile layer
      tileLayer = L.tileLayer(
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          // attribution: '&copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }
      );
      break;
    default:
      // tings
      break;
  }

  // ----- MAP LAYER ----- //
  // create a new map object at the window level
  // NOTE: we hard-code the initial map creation zoom level, as it affects the imgBounds calc below..
  // then once we have added the layers, we re-set the zoom level as defined in the CMS-specified zoom attribute
  window.masterplanMap = L.map("leafletMap", {
    scrollWheelZoom: enableScrollWheelZoom,
    center: [mapLat, mapLng],
    minZoom: window.lanserCommunity.base.zoomMin,
    maxZoom: window.lanserCommunity.base.zoomMax,
    zoom: 18,
    zoomSnap: 0.5,
    // preferCanvas:true,
    layers: [
      tileLayer,
      mapLayerGroups.radiuses,
      mapLayerGroups.stages,
      mapLayerGroups.precincts,
    ],
  });

  // ----- BASE/COMMUNITY MAP IMAGE ----- //
  // If there are two latLngBounds provided in baseMapLayerBounds (and the second bounds doesn't just have empty lat/lng values), we use both to calculate the bounding box of
  // the map image, otherwise we use the first latLngBounds, the map width/height and the imgScaleFactor to calculate the bounding box of the map image
  let imgBounds = [];
  if (
    baseMapLayerBounds.length === 2 &&
    baseMapLayerBounds[1].lat &&
    baseMapLayerBounds[1].lng
  ) {
    // use both latLngBounds to calculate the bounding box of the map image
    imgBounds = L.latLngBounds([baseMapLayerBounds[0], baseMapLayerBounds[1]]);
  } else {
          // use the first latLngBounds anc calc the rest. We calculate the resulting lat/lng of the bottom corner using
          // various leaflet methods to get the map container points and then convert back to latLng
          const imgW = baseMapImageLoad.naturalWidth;
          const imgH = baseMapImageLoad.naturalHeight;
          const desiredWidth  = imgW * baseMapScaleFactor;  
          const desiredHeight =  imgH * baseMapScaleFactor;
          // the containerPoint of the top left and bottom right corners of the map image
          const originContainerPoint = masterplanMap.latLngToContainerPoint(baseMapLayerBounds[0]);
          let destinationContainerPoint;
          if(isMobilehasmobileImageSet){
            const mobilimgW = baseMapImageMobileLoad.naturalWidth;
            const mobilimgH = baseMapImageMobileLoad.naturalHeight;
            const autoScale = Math.min(desiredWidth / mobilimgW, desiredHeight / mobilimgH);
            const renderedWidth  = mobilimgW * autoScale;
            const renderedHeight = mobilimgH * autoScale;
            destinationContainerPoint = L.point(
              originContainerPoint.x + renderedWidth,
              originContainerPoint.y + renderedHeight
            );
          }else{
          destinationContainerPoint = L.point(
            originContainerPoint.x + baseMapWidth * baseMapScaleFactor,
            originContainerPoint.y + baseMapHeight * baseMapScaleFactor
          );
    }


    // the latLng of the bottom right corner of the map image
    const destinationLatLngCoords = masterplanMap.containerPointToLatLng(
      destinationContainerPoint
    );

    imgBounds = L.latLngBounds([
      baseMapLayerBounds[0],
      destinationLatLngCoords,
    ]);
  }

  // Non Interactive Pane for 
   if (!masterplanMap.getPane('nonInteractivePane')) {
      const nonInteractivePane = masterplanMap.createPane('nonInteractivePane');
      nonInteractivePane.style.zIndex = 400;
      nonInteractivePane.style.pointerEvents = 'none'; // ← This is the key!
  }

  // ----- RADIUSES & DISTANCE MARKERS----- //
  const radiusRenderCanvas = L.canvas({
        pane: 'nonInteractivePane',
        interactive: false
  });

  const radiusDistances = [1000, 3000, 5000, 10000];
  const radiusLabels = ["1km", "3km", "5km", "10km"];
  radiusDistances.forEach((radius, i) => {
    // Create radius circle
    L.circle([mapLat, mapLng], {
      radius: radius,
      color: "#C06C39",
      fill: false,
      opacity: 0.5,
      renderer:radiusRenderCanvas,
    }).addTo(mapLayerGroups.radiuses);

    // Create north and south markers
    ["north", "south"].forEach((direction) => {
      const latLng = _moveLatLng(mapLat, mapLng, radius, direction);
      L.marker([latLng.lat, latLng.lng], {
        icon: L.divIcon({
          html: `<span class="radius-marker marker-${radiusLabels[i]}">${radiusLabels[i]}</span>`,
        }),
      }).addTo(mapLayerGroups.radiuses);
    });
  });

  // ----- STAGES ----- //
  // Loop through window.lanserCommunity.stages and add their image to the map layers
  // NOTE: this is currently unused as we are using precincts instead, as per client request (14 Oct)
  // for (let i = 0; i < window.lanserCommunity.stages.length; i++) {
  //   const svgElement = document.querySelector(`svg.stagemap_${i}`);
  //   const stage = L.svgOverlay(svgElement, imgBounds, {
  //     opacity: 1,
  //     zIndex: 1 + i,
  //   });
  //   // add a new stage layerGroup to the mapLayerGroups 'stages' object
  //   stage.addTo(mapLayerGroups.stages);
  // }

  // ----- PRECINCTS ----- //
  for (let i = 0; i < window.lanserCommunity.precincts.length; i++) {
    const precinctItem = window.lanserCommunity.precincts[i];
    const precsvgElement = document.querySelector(
      `svg.precinctmap[data-precinct-slug="${precinctItem.slug}"]`
    );
    if (precsvgElement && precinctItem) {
        const precinct = L.svgOverlay(precsvgElement, imgBounds, {
          opacity: 1,
          zIndex: 1 + i,
          bubblingMouseEvents: false,
        });
        // add a new precinct layerGroup to the mapLayerGroups 'precinct' object
        precinct.addTo(mapLayerGroups.precincts);
    }
  }

  // ----- AMENITIES ----- //
  for (let i = 0; i < lanserCommunity.amenities.length; i++) {
    const amenityItem = amenities[i];

    const amenityMarker = L.marker([amenityItem.lat, amenityItem.lng], {
      icon: L.divIcon({
        className: `amenity-icon ${amenityItem.icon}`,
        html: `<div class="pin"><svg><use href="#amenity-${amenityItem.icon}"></use></svg><span class="icon-bg"></span></div>`,
        iconSize: [56, 56],
        iconAnchor: [23, 56],
      }),
    })
      // .bindPopup(amenity.title)
      .on('click', function () {
        masterplanControls.showAmenityDetails(amenityItem.slug);
      });

    // add a new amenity layerGroup to the appropriate namespaced mapLayerGroups 'amenities__{categorySlug}' object
    const catName = 'amenities__' + amenityItem.categorySlug;
    amenityMarker.addTo(mapLayerGroups[catName]);
  }

  // ----- LOTS (circles) ----- //
  const lotCircles = generateLotCircles(
    masterplanMap,
    lanserCommunity.lots
  );
  lotCircles.forEach((circle) => {
    mapLayerGroups.lotCircles.addLayer(circle);
  });
  // ----- BASE/COMMUNITY MAP IMAGE ----- //
  const communityBaseLayer = L.imageOverlay(mapSrc, imgBounds, {
    opacity: baseMapOpacity,
    zIndex: 1,
  });
  communityBaseLayer.addTo(window.masterplanMap);
  // Updated map zoom
  window.masterplanMap.setZoom(mapZoom);

  // ----- RELEASES ----- //
  if (displayLotShapes) {
    // enable releases layerGroup on the map by default
    setTimeout(()=>{
      for (let i = 0; i < window.lanserCommunity.releases.length; i++) {
        const releaseItem = window.lanserCommunity.releases[i];
        const resvgElement = document.querySelector(`svg.releasemap[data-release-slug="${releaseItem.slug}"]`);
        if (resvgElement) {
          const release = L.svgOverlay(resvgElement, imgBounds, {
            opacity: 1,
            zIndex: 1 + i,
            bubblingMouseEvents:false
          });
          // add a new release layerGroup to the mapLayerGroups 'releases' object
          release.addTo(mapLayerGroups.releases);
        }
      }
      window.masterplanMap.addLayer(mapLayerGroups.releases);
        if (theMapWrapper) {
            // init the lot shapes & precinct shapes click-handlers/marker handlers
            initLotShapesHandler(theMapWrapper);
        }
    },500)
  }

  // ----- LAYERS CONTROL ----- //
  const layersControl = L.control
    .layers(
      null,
      {
        "Show Stages": mapLayerGroups.stages,
        "Show Precincts": mapLayerGroups.precincts,
      },
      {
        collapsed: true,
      }
    )
    .addTo(masterplanMap);
  // if displayLotShapes is true, add the 'releases' layerGroup to the layersControl
  // if (displayLotShapes) {z
  //   layersControl.addOverlay(mapLayerGroups.releases, "Show Releases");
  // }
  // afterwards, add each of the namespaced 'amenities__{categorySlug}' layerGroups to the layersControl
  allAmenityCategories.forEach((cat) => {
    const catSlug = "amenities__" + cat.slug;
    // layersControl.addOverlay(mapLayerGroups[catSlug], cat.title) // adds to the layersControl pane (in default OFF state)
    window.masterplanMap.addLayer(mapLayerGroups[catSlug], cat.title); // adds to the map itself (in default ON state)
  });

  if (theMapWrapper) {
    // init scroll listener, and zoom listener
    initZoomListener(mapLayerGroups);

    if(!isMobile){
      initScrollListener();
    }

    // initPrecinctShapesHandler(theMapWrapper) // disabled for now, as markers are used instead
    bindPrecinctMarkers(true, 18, mapLayerGroups);
    // init the resize observer
    if(!isMobile){
      resizeObserverInstance = initResizeObserver();
      resizeObserverInstance.observe(theMapWrapper);
    }

    // toggle Layer for default selected amenties
    const defaultCategory = window.lanserCommunityId == 6 
    ? "amenities__parks-recreation" 
    : "amenities__display-village";
    
    masterplanMap.whenReady(()=>{
      if (mapLayerGroups[defaultCategory]) {
        toggleAmenityLayerGroup(masterplanMap, defaultCategory, mapLayerGroups);
      }
    });
    // initial resize
    masterplanMap.invalidateSize(); 

  }
};

export default { initInteractiverMasterplan, masterplanControls };
